var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinLime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_569_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.001 0H1.43522C0.641672 0 0 0.626484 0 1.40105V18.0352C0 18.8097 0.641672 19.44 1.43522 19.44H18.001C18.7945 19.44 19.44 18.8097 19.44 18.039V1.40105C19.44 0.626484 18.7945 0 18.001 0ZM5.76745 16.5658H2.88183V7.2862H5.76745V16.5658ZM4.32464 6.02184C3.3982 6.02184 2.65022 5.27386 2.65022 4.35122C2.65022 3.42858 3.3982 2.68059 4.32464 2.68059C5.24728 2.68059 5.99527 3.42858 5.99527 4.35122C5.99527 5.27006 5.24728 6.02184 4.32464 6.02184ZM16.5658 16.5658H13.6839V12.0551C13.6839 10.9806 13.665 9.5947 12.1842 9.5947C10.6844 9.5947 10.4566 10.7679 10.4566 11.9791V16.5658H7.57856V7.2862H10.3427V8.55436H10.3807C10.7641 7.82536 11.7058 7.05459 13.1068 7.05459C16.0266 7.05459 16.5658 8.97581 16.5658 11.4742V16.5658Z",
    fill: "#DBFF6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_5991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.44,
    height: 19.44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLime);
export default __webpack_public_path__ + "static/media/linkedin-lime.155207ccf6aa2fa2f86d2b4a9814d63a.svg";
export { ForwardRef as ReactComponent };